// Keep the existing Options API metaInfo contract without the Vue 2-only plugin.
const active = new Set();
let queued = false;

function metaInfo(vm) {
  const option = vm.$options.metaInfo;
  return typeof option === 'function' ? option.call(vm) : option || {};
}

function updateHead() {
  queued = false;
  const instances = [...active];
  const root = instances.find(vm => vm === vm.$root);
  const page = instances.find(vm => vm !== vm.$root);
  if (!root) return;

  const info = [metaInfo(root), ...(page ? [metaInfo(page)] : [])];
  const title = info.map(item => item.title).filter(Boolean).pop();
  if (title) document.title = title;
  document.documentElement.lang = info[0].htmlAttrs?.lang || 'de';

  for (const tag of document.querySelectorAll('[data-hs-meta]')) tag.remove();

  for (const kind of ['meta', 'link']) {
    const tags = new Map();
    for (const item of info) {
      for (const tag of item[kind] || []) {
        tags.set(tag.vmid || tag.name || tag.property || tag.rel, tag);
      }
    }
    for (const tag of tags.values()) {
      const element = document.createElement(kind);
      for (const [name, value] of Object.entries(tag)) {
        if (name !== 'vmid' && value != null) element.setAttribute(name, value);
      }
      element.dataset.hsMeta = '';
      document.head.appendChild(element);
    }
  }
}

function scheduleHeadUpdate() {
  if (queued) return;
  queued = true;
  queueMicrotask(updateHead);
}

export function installMeta(app) {
  app.mixin({
    created() {
      if (!this.$options.metaInfo) return;
      this.$watch(() => metaInfo(this), scheduleHeadUpdate, { deep: true });
    },
    mounted() {
      if (!this.$options.metaInfo) return;
      active.add(this);
      scheduleHeadUpdate();
    },
    unmounted() {
      if (!this.$options.metaInfo) return;
      active.delete(this);
      scheduleHeadUpdate();
    },
  });
}
